<template>
  <div id="calendar-filter">
    <div class="calendar-box-header bg-color-skin-light-10">
      <div class="clearfix">
        <!-- Section Slide From date to month -->
        <div class="section-slider">
          <div class="block-slider">
            <input type="checkbox"  class="silder-checkbox" id="myslider" v-model="inputSwitch" @change="toggleCalendarSwitch(inputSwitch)">
            <label class="slider-label" for="myslider" v-show="mainCalendar">
              <span class="slider-inner"></span>
              <span class="slider"></span>
            </label>
          </div>
        </div>
        <div class="section-chevronl"><i class="fa fa-chevron-left" v-show="calendarDayDisp && nextPage" @click="setAddDate(-1)"></i></div>
        <div class="section-chevronl"><i class="fa fa-chevron-left" v-show="calendarMonthDisp && nextPage" @click="setAddMonth(-1)"></i></div>
        <span class="block-date" @click="toggleCalendar('index')">
          <div v-show="calendarDayDisp">
            <div class="section-left">{{ days[nowLang][selectedDay] }}</div>
            <div class="section-middle font-bold">{{ selectedDate }}</div>
          </div>
          <div v-bind:class="{ 'section-right': calendarDayDisp, 'block-month-only': calendarMonthDisp }">
            <span class="font-bold">{{ month[nowLang][selectedMonth-1].full }}</span><br>
            {{ setYearOutput(selectedYear) }}
          </div>
        </span>
        <div class="section-chevronr" v-show="calendarDayDisp && nextPage" @click="setAddDate(1)"><i class="fa fa-chevron-right"></i></div>
        <div class="section-chevronr" v-show="calendarMonthDisp && nextPage" @click="setAddMonth(1)"><i class="fa fa-chevron-right"></i></div>
        <div class="section-chevron" v-show="filterImageDisp">
          <img id="img-list" :src="require('static/images/' + [ filterImage ? 'filter-btn2' : 'filter-btn' ] + '.png')" @click.stop="toggleFilterImage(!filterImage)">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import assetsUtils from 'assets/js/utils'
export default {
  name: 'calendar_filter',
  data () {
    return {
      inputSwitch: this.checkSwitch
    }
  },
  watch: {
    checkSwitch () {
      this.inputSwitch = this.checkSwitch
    }
  },
  methods: {
    setYearOutput (date) {
      return assetsUtils.getYearOutput(date)
    }
  },
  props: [ 'toggleCalendarSwitch', 'toggleCalendar', 'toggleFilterImage', 'mainCalendar', 'checkSwitch', 'nextPage', 'calendarDayDisp', 'calendarMonthDisp', 'filterImageDisp', 'filterImage', 'days', 'selectedDay', 'selectedDate', 'month', 'selectedMonth', 'selectedYear', 'setAddDate', 'setAddMonth', 'nowLang' ]
}
</script>


// WEBPACK FOOTER //
// calendar_filter.vue?3c5bcf56